export const COMPONENT_ORIGIN_EXPIRATION_TIME = 60 * 5000 // 5 min
